module.exports = __webpack_public_path__ + "img/logos-banner.3f14af67.svg";